import { HeaderComponent } from "./index";
import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonContent,
    IonPage,
    IonText,
} from "@ionic/react";
import React from "react";
import { closeOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import "./NewFeaturesContent.css";
import { getLanguageCode } from "../utils/localeUtils";
import autocompleteImage from "../assets/images/new-features/6.1-autocomplete.png";
import calendarImage from "../assets/images/new-features/6.2-calendar.png";
import cropImage from "../assets/images/new-features/6.4-crop-match.png";
import complicationImage from "../assets/images/new-features/6.7-complication.png";
import compareHeatmapImage from "../assets/images/new-features/6.7-compare-heatmap.png";
import socialLogin from "../assets/images/new-features/6.10-social-sign-in.png";
import { getStringOrFallback } from "../i18n";
import { isAndroid, isIos } from "../services/platformDetection";
import { isFeatureAvailableCurrentLanguage } from "../utils/FeatureToggle";
import knvbLogo from "../assets/images/icon/knvb-logo-vector-2022.svg";
import knvbButton from "../assets/images/new-features/6.14.1-knvb-match.png";
import { ScorzaCard } from "./stats/ScorzaCard";

// test function so easily show different variants
// const isIos = () => {
//     return false;
// };

export const NewFeatureContent = (dismiss: () => void) => {
    const { t } = useTranslation();

    const language = getLanguageCode();

    return (
        <IonPage className="new-features-modal">
            <HeaderComponent
                title={t("help.WhatsNewModal.title")}
                onClickEndButton={() => {
                    dismiss();
                }}
                endBtnIconName={closeOutline}
                titleTestId="new-feature-title"
                endBtnTestId="new-feature-header-close"
            />
            <IonContent className="new-features">
                <ScorzaCard title="Scorza 1.0">
                    <IonCardContent>
                        <p>
                            Your complete football performance tracking
                            solution:
                        </p>
                        <ul>
                            <li>
                                Connect any compatible smartwatch to our
                                performance vest
                            </li>
                            <li>
                                Track speed, distance, heart rate and
                                football-specific metrics
                            </li>
                            <li>Review detailed post-match analytics</li>
                            <li>Monitor your progress over time</li>
                            <li>Compare performances across sessions</li>
                        </ul>
                    </IonCardContent>
                </ScorzaCard>
            </IonContent>
        </IonPage>
    );
};
